export function selectDefault(value) {
  return value || 'greyfinch'
}
